import { useCallback, useEffect } from 'react';
import { EKeyboardKey } from '../types/EKeyboardKey';
export var useSuggestKeyboard = function useSuggestKeyboard(_ref) {
  var onEnter = _ref.onEnter,
    onEscape = _ref.onEscape,
    onKeyboardSetItem = _ref.onKeyboardSetItem,
    suggestionsChildrenRef = _ref.suggestionsChildrenRef,
    listBoxRef = _ref.listBoxRef;
  var handleChildrenElementKeyDown = useCallback(function (e) {
    switch (e.key) {
      case EKeyboardKey.ArrowUp:
        onKeyboardSetItem('decrement');
        break;
      case EKeyboardKey.ArrowDown:
        onKeyboardSetItem('increment');
        break;
      case EKeyboardKey.Home:
      case EKeyboardKey.PageUp:
        onKeyboardSetItem('first');
        break;
      case EKeyboardKey.End:
      case EKeyboardKey.PageDown:
        onKeyboardSetItem('last');
        break;
      case EKeyboardKey.Escape:
        onEscape === null || onEscape === void 0 || onEscape();
        break;
      case EKeyboardKey.Enter:
        onEnter();
        break;
    }
  }, [onEscape, onEnter, onKeyboardSetItem]);
  useEffect(function () {
    if (!suggestionsChildrenRef.current || !listBoxRef.current) {
      return;
    }
    var currentSuggestionsChildrenRef = suggestionsChildrenRef.current;
    var currentListBoxRef = listBoxRef.current;
    currentSuggestionsChildrenRef.addEventListener('keydown', handleChildrenElementKeyDown);
    currentListBoxRef.addEventListener('keydown', handleChildrenElementKeyDown);
    return function () {
      currentSuggestionsChildrenRef.removeEventListener('keydown', handleChildrenElementKeyDown);
      currentListBoxRef.removeEventListener('keydown', handleChildrenElementKeyDown);
    };
  }, [handleChildrenElementKeyDown, suggestionsChildrenRef, listBoxRef]);
};